"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSchema = void 0;
const zod_1 = require("zod");
const argumentValidation_1 = require("./argumentValidation");
exports.requestSchema = zod_1.z
    .array(zod_1.z.object({
    geom: zod_1.z.string(),
    defaultHeights: zod_1.z.array(zod_1.z.string()),
}))
    .refine(argumentValidation_1.checkIfDefaultHeightsHasMinimumRequired, {
    message: 'defaultHeights must have at least one specified height.',
    path: ['validation'],
});
//# sourceMappingURL=soilFavoriteDepths.js.map